import React from 'react';
import { useTranslation } from 'react-i18next';
import HtmlParser from 'react-html-parser';

import SearchInput from 'components/SearchInput';

import classes from './Banner.module.scss';
import ZeroLicenses from 'containers/ZeroLicenses';

interface IProps {
  search: string;
  setSearch: (value) => void;
}

const Banner: React.FC<IProps> = ({ search, setSearch }) => {
  const { t } = useTranslation();

  return (
    <div className={classes.wrapper}>
      <div className={classes.content}>
        <div className={classes.title}>{HtmlParser(t('Electronic_licensing_system'))}</div>
        <div className={classes.description}>
          {t('Apply_license_permits')}
          <br />
          {t('License_platform_info')}
        </div>
        <div
          style={{
            marginTop: '32px',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            marginBottom: '2rem'
          }}
        >
          <SearchInput
            className={classes.searchInput}
            value={search}
            onChange={value => setSearch(value || '')}
            placeholder={window.matchMedia('(min-width: 576px)').matches ? t('Search_license_permit') : t('Search')}
          />
        </div>
        <ZeroLicenses />
      </div>
    </div>
  );
};

export default Banner;
